import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const SpacesIcon = forwardRef<SVGSVGElement, Props>((props, ref) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 16 16"
		xmlns="http://www.w3.org/2000/svg"
		ref={ref}
		{...props}
	>
		<path
			fill="currentColor"
			d="M1 3.42701C1 3.25744 1.19777 3.16481 1.32804 3.27336L2.82009 4.51674C2.93409 4.61174 3 4.75246 3 4.90085V11.0991C3 11.2475 2.93409 11.3883 2.82009 11.4833L1.32804 12.7266C1.19777 12.8352 1 12.7426 1 12.573V3.42701Z"
		></path>
		<path
			fill="currentColor"
			d="M15 3.42701C15 3.25744 14.8022 3.16481 14.672 3.27336L13.1799 4.51674C13.0659 4.61174 13 4.75246 13 4.90085V11.0991C13 11.2475 13.0659 11.3883 13.1799 11.4833L14.672 12.7266C14.8022 12.8352 15 12.7426 15 12.573V3.42701Z"
		></path>
		<path
			fill="currentColor"
			d="M4 4C4 3.44772 4.44772 3 5 3H11C11.5523 3 12 3.44772 12 4V12C12 12.5523 11.5523 13 11 13H5C4.44772 13 4 12.5523 4 12V4Z"
		></path>
	</svg>
))
